import { PropsWithChildren } from 'react';

import {
    useCategories,
    useI18n,
    useRelations,
    useUiGraph,
    useUiGraphLine,
    useUiNodes,
    useUiParameters,
} from '@queries';
import {
    useSyncAtom,
    parametersAtom,
    graphsAtom,
    graphLinesAtom,
    uiNodesAtom,
    relationsAtom,
    remoteI18nMapsAtom,
    categoriesAtom,
} from '@store';

export const QueryLoader = ({ children }: PropsWithChildren) => {
    const nodesRequest = useUiNodes();
    useSyncAtom(uiNodesAtom, nodesRequest.data);
    const categoriesRequest = useCategories();
    useSyncAtom(categoriesAtom, categoriesRequest.data);
    const relationsRequest = useRelations();
    useSyncAtom(relationsAtom, relationsRequest.data);

    const parametersRequest = useUiParameters();
    useSyncAtom(parametersAtom, parametersRequest.data);
    const graphsRequest = useUiGraph();
    useSyncAtom(graphsAtom, graphsRequest.data);
    const graphLinesRequest = useUiGraphLine();
    useSyncAtom(graphLinesAtom, graphLinesRequest.data);

    const i18nRequest = useI18n();
    useSyncAtom(remoteI18nMapsAtom, i18nRequest.data);
    return children;
};
